import React from "react"
import ButtonMaterial from "@material-ui/core/Button"

import DigitShelves_Logo from "./DS.svg"
import DigitMart_Logo from "./DM.svg"
import DigitCooler_Logo from "./DC.svg"

function BrandLoadingBar(props) {
  const {
    DM_BRAND_NAME = "digitmart",
    THEME_ASSET = "dev-theme-assets",
    LOGO_FOLDER = "digitmart",
    DOMAIN_ENV = "dev",
    location = {},
    _kc = {},
  } = window || {}

  const config = {
    DIGITCOOLER: DigitCooler_Logo,
    DIGITSHELVES: DigitShelves_Logo,
    DIGITMART: DigitMart_Logo,
  }

  const ourProudctBrand = localStorage?.getItem("viewStoreType")
  let BRAND_NAME = ""
  let isOurProudctBrandFlag = false

  if (ourProudctBrand === "" || ourProudctBrand === null) {
    isOurProudctBrandFlag = false
  } else {
    isOurProudctBrandFlag = ourProudctBrand?.length > 0
    BRAND_NAME = ourProudctBrand
  }

  let DynamicImageUrl =
    DOMAIN_ENV === "portal"
      ? `https://stdigitmartproddata.blob.core.windows.net/${THEME_ASSET}/${LOGO_FOLDER}/large_dark_logo.png`
      : `https://stdgrabdatanonprod001.blob.core.windows.net/${THEME_ASSET}/${LOGO_FOLDER}/large_dark_logo.png`
  if (isOurProudctBrandFlag) {
    DynamicImageUrl = config[BRAND_NAME] ? config[BRAND_NAME] : DigitMart_Logo
  }

  return (
    <div className="dm-loadBar" style={{ height: 120 }}>
      <div>
        <img
          alt="brandlogo"
          className="dm-loadBar-brand-logo"
          src={DynamicImageUrl}
        />

        <div className="dm-lds-ellipsis">
          <div className="dm-lds-ellipsis-dot"></div>
          <div className="dm-lds-ellipsis-dot"></div>
          <div className="dm-lds-ellipsis-dot"></div>
          <div className="dm-lds-ellipsis-dot"></div>
        </div>
      </div>
    </div>
  )
}

export { BrandLoadingBar }
export default BrandLoadingBar
